<template>
  <div>
    <div class="new-form-wrapper">
      <b-overlay :show="busy">
        <page-blocks
          :organization="organization"
          :page="page"
          :blocks="blocks"
          @click-modify="onClickModify"
          @click-duplicate="onClickDuplicate"
          @click-delete="onClickDelete"
          @click-add-before="onClickAddBefore"
          @click-add-after="onClickAddAfter"
          @reorder="onReorder"
        >
          <template #bookings>
            <slot name="bookings"></slot>
          </template>
          <template #products>
            <slot name="products"></slot>
          </template>
        </page-blocks>
      </b-overlay>
    </div>
    <div class="text-center">
      <b-button
        variant="outline-primary"
        size="lg"
        @click="onClickAppend"
        :disabled="busy"
      >
        <i class="fa fa-fw fa-plus"></i>
      </b-button>
    </div>
    <add-block-modal
      :organization="organization"
      :page="page"
      :blocks="blocks"
      @add="onClickAddWithType"
    ></add-block-modal>
    <page-one-column-modal
      :organization="organization"
      :page="page"
      :block="block"
      :after="after"
      @saved="onSaved"
    ></page-one-column-modal>
    <page-hero-modal
      :organization="organization"
      :page="page"
      :block="block"
      :after="after"
      @saved="onSaved"
    ></page-hero-modal>
    <page-card-modal
      :organization="organization"
      :page="page"
      :block="block"
      :after="after"
      @saved="onSaved"
    ></page-card-modal>
    <page-form-card-modal
      :organization="organization"
      :page="page"
      :block="block"
      :after="after"
      @saved="onSaved"
    ></page-form-card-modal>
    <page-document-card-modal
      :organization="organization"
      :page="page"
      :block="block"
      :after="after"
      @saved="onSaved"
    ></page-document-card-modal>
    <page-calendar-modal
      :organization="organization"
      :page="page"
      :block="block"
      :after="after"
      @saved="onSaved"
    ></page-calendar-modal>
    <page-location-card-modal
      :organization="organization"
      :page="page"
      :block="block"
      :after="after"
      @saved="onSaved"
    ></page-location-card-modal>
    <page-package-card-modal
      :organization="organization"
      :page="page"
      :block="block"
      :after="after"
      @saved="onSaved"
    ></page-package-card-modal>
    <page-class-card-modal
      :organization="organization"
      :page="page"
      :block="block"
      :after="after"
      @saved="onSaved"
    ></page-class-card-modal>
    <page-amilia-modal
      :organization="organization"
      :page="page"
      :type="type"
      :block="block"
      :after="after"
      @saved="onSaved"
    ></page-amilia-modal>
    <page-amilia-activity-list-modal
      :organization="organization"
      :page="page"
      :type="type"
      :block="block"
      :after="after"
      @saved="onSaved"
    ></page-amilia-activity-list-modal>
    <page-tile-modal
      :organization="organization"
      :page="page"
      :block="block"
      :after="after"
      @saved="onSaved"
    ></page-tile-modal>
    <page-video-tile-modal
      :organization="organization"
      :page="page"
      :block="block"
      :after="after"
      @saved="onSaved"
    ></page-video-tile-modal>
    <page-video-card-modal
      :organization="organization"
      :page="page"
      :block="block"
      :after="after"
      @saved="onSaved"
    ></page-video-card-modal>
    <page-my-account-link-modal
      :organization="organization"
      :page="page"
      :block="block"
      :after="after"
      @saved="onSaved"
    ></page-my-account-link-modal>
    <page-staff-login-link-modal
      :organization="organization"
      :page="page"
      :block="block"
      :after="after"
      @saved="onSaved"
    ></page-staff-login-link-modal>
    <page-bookings-modal
      :organization="organization"
      :page="page"
      :block="block"
      :after="after"
      @saved="onSaved"
    ></page-bookings-modal>
    <page-products-modal
      :organization="organization"
      :page="page"
      :block="block"
      :after="after"
      @saved="onSaved"
    ></page-products-modal>
    <PageEcommerceModal
      :organization="organization"
      :page="page"
      :block="block"
      :after="after"
      @saved="onSaved"
    ></PageEcommerceModal>
    <PageFormAnswersModal
      :organization="organization"
      :page="page"
      :block="block"
      :after="after"
      @saved="onSaved"
    ></PageFormAnswersModal>
    <page-team-standings-modal
      :organization="organization"
      :page="page"
      :block="block"
      :after="after"
      @saved="onSaved"
    ></page-team-standings-modal>
    <page-teams-schedule-modal
      :organization="organization"
      :page="page"
      :block="block"
      :after="after"
      @saved="onSaved"
    ></page-teams-schedule-modal>
    <page-player-stats-modal
      :organization="organization"
      :page="page"
      :block="block"
      :after="after"
      @saved="onSaved"
    ></page-player-stats-modal>
    <page-attendance-modal
      :organization="organization"
      :page="page"
      :block="block"
      :after="after"
      @saved="onSaved"
    ></page-attendance-modal>
    <page-radio-buttons-modal
      :organization="organization"
      :page="page"
      :block="block"
      :after="after"
      @saved="onSaved"
    ></page-radio-buttons-modal>
    <page-audio-modal
      :organization="organization"
      :page="page"
      :block="block"
      :after="after"
      @saved="onSaved"
    ></page-audio-modal>

    <PageHtmlModal
      :organization="organization"
      :page="page"
      :block="block"
      :after="after"
      @saved="onSaved"
    />
    <PageSearchModal
      :organization="organization"
      :page="page"
      :block="block"
      :after="after"
      @saved="onSaved"
    />
    <PageAlertModal
      :organization="organization"
      :page="page"
      :block="block"
      :after="after"
      @saved="onSaved"
    />
    <PageTabsModal
      :organization="organization"
      :page="page"
      :block="block"
      :after="after"
      @saved="onSaved"
    />
    <PageTableModal
      :organization="organization"
      :page="page"
      :block="block"
      :after="after"
      @saved="onSaved"
    />
    <PageLinksModal
      :organization="organization"
      :page="page"
      :block="block"
      :after="after"
      @saved="onSaved"
    />
  </div>
</template>

<script>
  import PageBlocks from './PageBlocks'
  import AddBlockModal from './AddBlockModal'
  import PageOneColumnModal from './PageOneColumnModal'
  import PageHeroModal from './PageHeroModal'
  import PageCardModal from './PageCardModal'
  import PageHtmlModal from './PageHtmlModal'
  import PageLinksModal from './PageLinksModal'
  import PageAlertModal from './PageAlertModal'
  import PageTileModal from './PageTileModal'
  import PageEcommerceModal from './PageEcommerceModal'
  import PageVideoTileModal from './PageVideoTileModal'
  import PageVideoCardModal from './PageVideoCardModal'
  import PageMyAccountLinkModal from './PageMyAccountLinkModal'
  import PageStaffLoginLinkModal from './PageStaffLoginLinkModal'
  import PageFormCardModal from './PageFormCardModal'
  import PageDocumentCardModal from './PageDocumentCardModal'
  import PageCalendarModal from './PageCalendarModal'
  import PageLocationCardModal from './PageLocationCardModal'
  import PagePackageCardModal from './PagePackageCardModal'
  import PageClassCardModal from './PageClassCardModal'
  import PageAmiliaModal from './PageAmiliaModal'
  import PageBookingsModal from './PageBookingsModal'
  import PageProductsModal from './PageProductsModal'
  import PageAmiliaActivityListModal from './PageAmiliaActivityListModal'
  import PageFormAnswersModal from './PageFormAnswersModal'
  import PageSearchModal from './PageSearchModal'
  import PageTeamStandingsModal from './PageTeamStandingsModal'
  import PageTeamsScheduleModal from './PageTeamsScheduleModal'
  import PagePlayerStatsModal from './PagePlayerStatsModal'
  import PageAttendanceModal from './PageAttendanceModal'
  import PageRadioButtonsModal from './PageRadioButtonsModal'
  import PageTabsModal from './PageTabsModal'
  import PageTableModal from './PageTableModal'
  import PageAudioModal from './PageAudioModal'

  export default {
    props: {
      organization: Object,
      page: Object,
    },
    components: {
      PageBlocks,
      AddBlockModal,
      PageOneColumnModal,
      PageHeroModal,
      PageCardModal,
      PageTileModal,
      PageVideoTileModal,
      PageVideoCardModal,
      PageMyAccountLinkModal,
      PageStaffLoginLinkModal,
      PageFormCardModal,
      PageDocumentCardModal,
      PageCalendarModal,
      PageLocationCardModal,
      PagePackageCardModal,
      PageClassCardModal,
      PageAmiliaModal,
      PageBookingsModal,
      PageProductsModal,
      PageAmiliaActivityListModal,
      PageEcommerceModal,
      PageFormAnswersModal,
      PageTeamStandingsModal,
      PageTeamsScheduleModal,
      PagePlayerStatsModal,
      PageAttendanceModal,
      PageRadioButtonsModal,
      PageHtmlModal,
      PageSearchModal,
      PageAlertModal,
      PageTabsModal,
      PageTableModal,
      PageLinksModal,
      PageAudioModal
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        blocks: _.cloneDeep(this.page.blocks),
        block: null,
        type: null,
        after: null, // Id of the block to add after
      }
    },
    methods: {
      type2modal(type) {
        if (type != 'amilia-activity-list' &&
          type.indexOf('amilia') === 0)
          return 'page-amilia-modal'
        if (type == 'am-class-card') return 'page-class-card-modal'
        if (type == 'ecommerce') return 'page-ecommerce-card-modal'
        return `page-${type}-modal`
      },
      onClickAppend() {
        this.block = null
        this.type = null
        this.after = this.blocks.length > 0 ? this.blocks[this.blocks.length-1].id : null
        this.$bvModal.show('add-block-modal')
      },
      onClickAddWithType(type) {
        const modal = this.type2modal(type)
        this.block = null
        this.type = type
        this.$bvModal.show(modal)
      },
      onClickModify(block, index) {
        const modal = this.type2modal(block.type)
        this.block = block
        this.type = block.type
        this.$bvModal.show(modal)
      },
      onClickDuplicate(block, index) {
        const modal = this.type2modal(block.type)
        this.block = _.clone(block)
        this.block.id = undefined
        this.after = this.blocks[index] || null
        if (this.after) this.after = this.after.id
          this.type = this.block.type
        this.$bvModal.show(modal)
      },
      onClickDelete(block, index) {
        this.$bvModal.msgBoxConfirm(trans('remove_confirm'), {
          title: trans('remove'),
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: trans('remove'),
          cancelTitle: trans('cancel'),
        })
        .then(value => {
          if (value) {
            this.busy = true
            this.error = null
            let url = `/organization/${this.organization.id}/page/${this.page.id}/block/${block.id}`
            axios.delete(url)
            .then(response => {
              this.loadBlocks()
            })
            .catch(error => {
              this.busy = false
              this.error = _.errorFromAjax(error)
              _.toastError(this, this.error)
            })
          }
        })
      },
      onClickAddBefore(block, index) {
        this.block = null
        this.after = this.blocks[index - 1] || null
        if (this.after) this.after = this.after.id
        this.$bvModal.show('add-block-modal')
      },
      onClickAddAfter(block, index) {
        this.block = null
        this.after = this.blocks[index] || null
        if (this.after) this.after = this.after.id
        this.$bvModal.show('add-block-modal')
      },
      onSaved(block) {
        if (['bookings', 'products'].indexOf(block.type) >= 0) {
          window.location.reload()
        } else {
          this.loadBlocks()
        }
        this.$bvModal.hide('add-block-modal')
      },
      onReorder(ids) {
        if (_.isEqual(ids, _.map(this.blocks, 'id'))) return
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/page/${this.page.id}/block/order`
        axios.post(url, {ids: ids})
        .then(response => {
          this.busy = false
          this.blocks = response.data
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          _.toastError(this, this.error)
        })
      },
      loadBlocks() {
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/page/${this.page.id}/block`
        axios.get(url)
        .then(response => {
          this.busy = false
          this.blocks = response.data
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          _.toastError(this, this.error)
        })
      },
    },
    mounted() {
      window.pageDesign = this
    },
  }
</script>
